var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"profile-politica",attrs:{"row":"","wrap":"","pa-4":"","ma-4":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }